import Vue from 'vue'
import App from './App.vue'
import router from './router/router.js'
import ElementUI from 'element-ui';
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  name:"摩米贝尔科技有限公司",
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

Array.prototype.contains = function ( needle ) {
  for (var i=0;i<this.length;i++) {
    if (this[i] == needle)
      return true;
  }
  return false;
}